// 使用快递提供的scheme协议
export default function useExpressScheme (scheme) {
  window.location.href = scheme
}
